<template>
  <template v-if="showCalendar">
    <ListCalendarPicker
      class="maincalendar"
      :selectedOption="selectedOption" 
      :options="options"
      :selectionmode="false"
      @set-data="setData"
      @close-picker="showCalendar = false" />
  </template>
  <template v-else>
    <smallWeekSlider
      @showday="setActiveDay"
      @calendar-view="showCalendarView"
      @update-week="updateWeek"
      :activeday="activeday"
      v-if="selectedOption.id != 3"
      :selectedWeek="selectedWeek" /> 
    <smallMonthSlider
      v-else
      @showday="setActiveDay"
      @calendar-view="showCalendarView"
      @update-week="updateWeek"
      @monthselected="monthSelected"
      :startyear="2021"
      :endyear="2025"
      :selectedMonth="selectedMonth" /> 
    <div class="listwrapper">
      <Spinner class="spinner" v-if="isUpdatingHorario"/> 
      <mev 
        v-show="!isUpdatingHorario && selectedOption.id != 3"
        ref="eventList1"
        :lang="$i18n.locale"
        @change-day="setActiveDayForScrolling"
        :activeday="activeday"
        :selectedWeek="selectedWeek"
        :showEmptyDays="true"
        :aulas="aulas" />      
      <EventList
        v-show="!isUpdatingHorario && selectedOption.id == 3"
        ref="eventList2"
        @change-day="setActiveDayForScrolling"
        :lang="$i18n.locale"
        :weekstart="selectedWeek.start" 
        :aulas="aulas" />
    </div>
    <FilterNavigation
      :selectedOption="selectedOption"
      @setOption="setOption"
      :options="options" />
  </template>
</template>

<script>
import { computed } from "vue";
import { EventList, mev } from "umaui";
import { i18n } from '@/main.js';
import FilterNavigation from "@/components/filterNavigation/filterNavigation.vue";
import SmallWeekCalendar from "@/components/smallWeekCalendar/smallWeekCalendar.vue";
import ListCalendarPicker from "@/containers/mobile/ListCalendarPicker.vue";
import smallWeekSlider from "@/components/smallWeekSlider/smallWeekSlider.vue";
import Spinner from '@/components/spinLoader.vue';
import SmallMonthSlider from "@/components/smallMonthSlider/smallMonthSlider.vue";
import { useMenuStore } from "@/stores/menu.ts";
import { useEventSearch } from "@/stores/eventSearch.ts";
import { useHorarios } from "@/stores/horarios.ts";


let weekdayFormatter = null;
let dayFormatter = null;
let monthFormatter = null;


export default {
  name: "EventsCalendarList",
  emits: ["setOption","showcalendar"],
  components: {
    EventList,
    mev,
    FilterNavigation,
    SmallWeekCalendar,
    ListCalendarPicker,
    smallWeekSlider,
    Spinner,
    SmallMonthSlider
  },
  setup(){
    const menuStore = useMenuStore();
    const options = computed(() => menuStore.menuItems);
    const selectedOption = computed(() => menuStore.currentSelected);

    const eventsearch = useEventSearch();
    const selectedWeek = computed(()=> eventsearch.selectedWeek);
    const currentFilters = computed(()=>eventsearch.currentFilters);
    function updateSelectedWeek(selectedWeek){
      eventsearch.setSelectedWeek(selectedWeek);
    }

    const horarios = useHorarios();
    const aulas = computed(()=>horarios.aulas);
    const isUpdatingHorario = computed(()=>horarios.isUpdatingHorario)
    
    function fetchHorarios(){
      horarios.fetchHorario();
    }


    return {
      options,
      selectedOption,
      selectedWeek,
      updateSelectedWeek,
      aulas,
      fetchHorarios,
      isUpdatingHorario,
      currentFilters
    }
  },
  computed: {
    selectedMonth(){
      return {
        year: this.selectedWeek.start.getFullYear(), 
        month: this.selectedWeek.start.getMonth()
      }
    }
  },
  data(){
    return {
      activeday: 2,
      showCalendar: false
    }
  },
  created(){
    const idioma = i18n.global.locale == "pt" ? "pt-PT" : "en-uk" ;
    weekdayFormatter = new Intl.DateTimeFormat(idioma, { weekday: 'long' });
    dayFormatter = new Intl.DateTimeFormat(idioma, { day: '2-digit' });
    monthFormatter = new Intl.DateTimeFormat(idioma, { month: 'long' });
  },
  methods:{
    monthSelected(month){
      const selectedDates = {
        "start": new Date(month.year, month.month, 1),
        "end": new Date(month.year, month.month + 1, 0)
      }
      this.updateSelectedWeek(selectedDates);
      this.fetchHorarios();
    },
    setOption(option){
      this.$emit('setOption', option)
    },
    setData(data){
      this.activeday = 2;
      this.updateSelectedWeek(data);
      this.searchByWeek(data);
    },
    showCalendarView(){
      this.showCalendar = true;
      this.$emit("showcalendar");
    },
    setActiveDayForScrolling(dia){
      this.activeday = dia;
    },
    setActiveDay(dia){
      if(this.selectedOption.id != 3){
        this.$refs.eventList1.scrollToDay(dia.value);
      }else{
        this.$refs.eventList2.scrollToDay(dia.value);
      }
      this.activeday = dia.value;
    },
    updateWeek(week){
      const data = {
        start: week.days[0].date,
        end: week.days[6].date,
      }
      this.searchByWeek(data);
    },
    searchByWeek(week){
      this.currentFilters.date = week;
      this.updateSelectedWeek(week); 
      this.fetchHorarios()
    },
  }
};
</script>

<style scoped>
.listwrapper{
  position: relative;
  min-height: 60vh;
}

.spinner{
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%,-10%);
}

@media only screen and (max-width: 767px) {
  .maincalendar{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
  }
}
</style>